// 单据生成类型
import IN_STORE_TYPE from './in_store'
import OUT_STORE_TYPE from './out_store'
export default {
	...IN_STORE_TYPE,
	...OUT_STORE_TYPE
}
